import React from 'react'
import GrowthWheelEditorLanding from '../../components/GrowthWheelComponents/GrowthWheelEditorLanding'

const GrowthWheelEditor = () => {
  return (
    <main className="container-fluid mb-5">
      <GrowthWheelEditorLanding />
    </main>
  )
}

export default GrowthWheelEditor
